const config = {
    // baseUrl: 'http://localhost:3001' // For Local
    baseUrl: 'https://siaphalal.com/triphalalapi' // For Live
}

export default config;